import * as React from 'react';
import { zAppHeaderContainer } from '../theme/z';
import { colorAppHeaderBackground, colorContrast, colorSlate, colorWhite } from '../theme/color';
import { constantHeaderHeight } from '../theme/constant';
import { classes, media, style } from 'typestyle';
import {betweenJustified, center, centerCenter, content, flex1, horizontal, inlineRoot, start} from 'csstips';
import { Logo } from './logo';
import {mediaMobileOnly, mediaTablet} from '../theme/media';
import { important, percent, px, rem } from 'csx';
import { resetAnchorStyles } from '../theme/reset';
import { observer } from 'mobx-react';
import {ChannelSchema} from '../types/schema';
import {User} from '../types/user';
import UserStatusBar from './user/status-bar';
import {SVGIcon} from './svg-icon';
import {Badge} from './badge';
import AppBreadcrumbs from './app-breadcrumbs';
import {BasketModel} from "../modules/basket/model";


export interface AppHeaderProps {
  shunted?: boolean;
  solid?: boolean;
  showMenu: boolean;
  basket: BasketModel;
  accountURI: string;
  user: User;
  channel: ChannelSchema;
  logoImage: string;
  activePath: string;
  onClickSignIn(event: React.MouseEvent<any>): void;
  onClickSignOut(event: React.MouseEvent<any>): void;
  onClickLink(event: React.MouseEvent<any>): void;
  onClickMenu(event: React.MouseEvent<any>): void;
  onClickClose(event: React.MouseEvent<any>): void;
}

@observer
export class AppHeader extends React.Component<AppHeaderProps, any> {
  render() {
    const { props } = this;

    const className = classes(
      AppHeader.styles.container,
      props.solid && AppHeader.styles.containerSolid,
      props.shunted && AppHeader.styles.containerShunted
    );

    return (
      <div id="app-header" className={className}>
        <div className={AppHeader.styles.inner}>
          <div className={AppHeader.styles.logoContainer}>
            <a className={AppHeader.styles.logoLink} href="/" onClick={props.onClickLink}>
              <Logo logoImage={props.logoImage} width={60} />
            </a>
          </div>
          <AppBreadcrumbs className={AppHeader.styles.breadcrumbsDesktop}/>
        </div>
        <AppBreadcrumbs light={true} className={AppHeader.styles.breadcrumbsMobile}/>
        <div className={AppHeader.styles.menuGroup}>
          <a href="/browse" className={classes(AppHeader.styles.menu, AppHeader.styles.menuMaybeMobile)} onClick={props.onClickLink}>
            <SVGIcon.Browse />
            <span className={AppHeader.styles.menuMaybeMobile}>Browse</span>
          </a>
          <a href="/search" className={AppHeader.styles.menu} onClick={props.onClickLink}>
            <SVGIcon.Search size={22} />
            <span className={AppHeader.styles.menuMaybeMobile}>Search</span>
          </a>
          <a href="/checkout" className={AppHeader.styles.menu} onClick={props.onClickLink}>
            <SVGIcon.Basket size={22} />
            {!!props.basket && props.basket.tracks.length > 0 && (
              <Badge className={AppHeader.styles.basketBadge}>
                { props.basket.tracks.length }
              </Badge>
            )}
            <span className={AppHeader.styles.menuMaybeMobile}>Basket</span>
          </a>
          <UserStatusBar
            className={!props.user && AppHeader.styles.statusBar}
            onlyAvatarMobile={true}
          />
          <div id="app-menu-toggle" className={AppHeader.styles.menu} onClick={props.onClickMenu}>
            <SVGIcon.Menu />
          </div>
        </div>
      </div>
    )
  }


  static styles = {
    container: style({
      ...horizontal,
      ...betweenJustified,
      ...center,
      zIndex: zAppHeaderContainer,
      position: 'fixed',
      background: colorAppHeaderBackground.toString(),
      top: 0,
      left: 0,
      right: 0,
      padding: 0,
      transform: 'translate3d(0,0,0)',
      height: constantHeaderHeight,
      fontSize: px(16),
    }),
    containerShunted: style({
      transform: `translate3d(0,${constantHeaderHeight},0)`
    }),
    containerSolid: style({
      background: important(colorSlate.toString())
    }),
    inner: style({
      ...flex1,
      ...horizontal,
      ...betweenJustified,
      ...center,
      height: constantHeaderHeight,
      padding: '0 0 0 16px'
    }),
    breadcrumbsMobile: style(
      {
        position: 'fixed',
        left: 0,
        right: 0,
        top: percent(100),
        width: percent(100),
      },
      mediaTablet({ display: 'none' })
    ),
    breadcrumbsDesktop: style(
      {
        background: 'transparent !important',
        width: percent(100),
        $nest: {
          '& a': {
            fontSize: rem(1.125)
          }
        }
      },
      mediaMobileOnly({ display: 'none' })
    ),
    logoContainer: style({
      ...inlineRoot,
      ...content,
      position: 'relative',
      zIndex: 1,
    }),
    logoLink: style({
      ...horizontal,
      ...start,
      color: important(colorWhite.toString()),
      textDecoration: important('none'),
      $nest: { ...resetAnchorStyles(colorWhite.toString(), true) }
    }),
    menuGroup: style({
      ...horizontal,
      padding: '0 8px',
      height: constantHeaderHeight,
    }),
    menu: style({
      ...centerCenter,
      position: 'relative',
      minWidth: '44px',
      height: constantHeaderHeight,
      cursor: 'pointer',
      color: 'white',
      margin: '0 1rem',
      $nest: {
        '& span': {
          marginLeft: px(5),

        }
      }
    },
    media({maxWidth: 768}, {
      margin: 0,
    })),
    menuMaybeMobile: style(
      media({maxWidth: 768}, {
        display: 'none'
      })
    ),
    statusBar: style({
      padding: '0 8px'
    }),
    basketBadge: style({
      position: 'absolute',
      color: colorWhite.toString(),
      top: px(8),
      left: px(14)
    })
  }
}